export default {
  hint: "Mit PFREUNDT Load & Go wird der gesamte Auftragsablauf für alle Beteiligten digital.",
  password: "Passwort",
  signIn: "Anmelden",
  email: "E-Mail",
  error: "Beim Login ist ein Fehler aufgetreten",
  forcedLogout:
    "Sie wurden abgemeldet, da ihre Session abgelaufen ist. Bitte melden Sie sich erneut an.",
};
